/**
 * @param preferenceCenterForm {HTMLFormElement}
 * @return {void}
 */
module.exports = function PreferenceCenter_showPrivacyPolicyError(preferenceCenterForm) {
    const label = preferenceCenterForm.querySelector('[data-component="PrivacyPolicyLabel"]');
    if (label instanceof HTMLLabelElement) {
        label.classList.add("invalid");
    }
}